<template>
  <footer class="app-footer">
    <div class="footer-content">
      <!-- Social Media Section -->
      <div class="footer-social">
        <h4>Seuraa meitä</h4>
        <div class="social-links">
          <a href="https://x.com/raviremmi" target="_blank" rel="noopener noreferrer" class="social-link">
            <span class="social-icon">𝕏</span>
            @raviremmi
          </a>
        </div>
      </div>
      
      <!-- Existing Footer Links -->
      <div class="footer-links">
        <router-link to="/terms-of-service" class="footer-link">Käyttöehdot</router-link>
        <span class="footer-separator">|</span>
        <router-link to="/privacy-policy" class="footer-link">Tietosuojaseloste</router-link>
        <span class="footer-separator">|</span>
        <a href="mailto:info@raviremmi.com" class="footer-link">Tekniset ongelmat</a>
        <span class="footer-separator">|</span>
        <span class="footer-text">© 2025 Raviremmi</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  background-color: #0a192f;
  border-top: 1px solid #1e3a5f;
  padding: 20px 0;
  margin-top: auto;
  width: 100%;
}

.footer-content {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Social Media Section */
.footer-social {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #1e3a5f;
}

.footer-social h4 {
  color: #e6f1ff;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 15px 0;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #64ffda;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid rgba(100, 255, 218, 0.3);
  background: rgba(100, 255, 218, 0.05);
  transition: all 0.3s ease;
}

.social-link:hover {
  color: #52d6c0;
  background: rgba(100, 255, 218, 0.1);
  border-color: rgba(100, 255, 218, 0.5);
  transform: translateY(-1px);
}

.social-icon {
  font-size: 1.2rem;
  font-weight: bold;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.footer-link {
  color: #64ffda;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.footer-separator {
  color: #8892b0;
  font-size: 0.9rem;
}

.footer-text {
  color: #8892b0;
  font-size: 0.9rem;
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .footer-social {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
  
  .footer-social h4 {
    font-size: 1rem;
  }
  
  .social-links {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  
  .social-link {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
  
  .footer-separator {
    display: none;
  }
}
</style>
